import { render, staticRenderFns } from "./ChatBlock.vue?vue&type=template&id=6b487b3a&"
import script from "./ChatBlock.vue?vue&type=script&lang=js&"
export * from "./ChatBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports